<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm sending</v-card-title>
    <v-card-text>Are you sure you want to email invoice {{ipfc.ipfc_nr}} ?  <B>(Sending may take a few seconds)</B></v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="clicked" class="warning mx-2" small @click="sentIpfcByEmail">Yes</v-btn>
      <v-btn :disabled="clicked" color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      clicked: false,
      ipfc_encrid: null,
      ipfc: {}
    }
  },
  methods: {
    open(ipfc_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/task/inpt/ipfc/getIpfcTmp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getIpfcTmp"
          },
          getIpfcTmp: {
            ipfc_encrid: ipfc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.ipfc = res.data.getIpfcTmp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sentIpfcByEmail() { 
      this.clicked = true;
      this.$axios
        .post("ares/json/ares/task/inpt/ipfc/sentIpfcByEmail.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "sentIpfcByEmail"
          },
          sentIpfcByEmail: {
            ipfc_encrid: this.ipfc.ipfc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.sentIpfcByEmail.text,
              color: res.data.sentIpfcByEmail.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

